import React, { JSX } from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { sanitize } from '@ibe/services';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';

import getIconForItemTye from './getItemForItemType';
import SummaryTabs from './SummaryTabs';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import Dates from '../Dates';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    item,
    isOpen,
    showInfo,
    showTraveler,
    showSsr,
    booking,
    onDelete,
    withIconColumn,
    hideSinglePrices,
    showNumberOfPerson,
    customPriceModifier,
    order,
    showPricePlusMinus
  } = props;

  const icon = getIconForItemTye(item.itemType);

  const { t } = useTranslation('summary', fallback, Keys);
  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';

  const InfoTabContent = (): JSX.Element => {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: sanitize(item.name) }} />
        <div dangerouslySetInnerHTML={{ __html: sanitize(item.description) }} />
        {numberOfPersonLabel ? (
          <div dangerouslySetInnerHTML={{ __html: sanitize(numberOfPersonLabel) }} />
        ) : null}
      </>
    );
  };

  const customPrice = customPriceModifier && customPriceModifier(item);
  return (
    <SummaryItem
      title={item.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={item.description}
      icon={<Icon icon={icon} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      withIconColumn={withIconColumn}
      hideSinglePrices={hideSinglePrices}
      order={order?.Base}
      numberOfPerson={numberOfPersonLabel}
      showPricePlusMinus={showPricePlusMinus}
    >
      {(showInfo || showTraveler || showSsr) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoTabContent />}
          showInfo={showInfo}
          showTraveler={showTraveler}
          showSsr={showSsr}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
